import {Check} from '@material-ui/icons';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import React from 'react';
import cn from 'classnames';
import './FileContainer.scss';

export type FileItemContainerProps = {
  isLocal?: boolean;
  className?: string;
  selected: boolean;
  children: React.ReactNode;
  overlayElement?: React.ReactNode;
  showSelection?: boolean;
  onSelect?: (event: React.MouseEvent<HTMLDivElement>) => void;
  onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
};

export const FileItemContainer = ({
  children,
  overlayElement,
  isLocal = false,
  className,
  showSelection = true,
  selected,
  onSelect,
  onClick,
}: FileItemContainerProps) => (
  <div className={cn('file-item-container', className, selected && 'selected')}>
    <div className="file-item-container_overlay" onClick={onClick}>
      {showSelection && (
        <FileAdornment
          isLocal={isLocal}
          selected={selected}
          onClick={(e: React.MouseEvent<HTMLDivElement>) => {
            e.stopPropagation();
            onSelect && onSelect(e);
          }}
        ></FileAdornment>
      )}
      {overlayElement}
    </div>
    <div className={cn('file-item-container_content', selected && 'selected')}>
      {children}
    </div>
  </div>
);

export const FileAdornment = ({
  isLocal,
  selected,
  onClick,
}: {
  isLocal?: boolean;
  selected?: boolean;
  onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
}) => (
  <div className="file-adornment__base" onClick={onClick}>
    {selected ? (
      <Check className="file-adornment__base file-adornment__selected" />
    ) : (
      isLocal && (
        <CloudUploadIcon className="file-adornment__base file-adornment__isLocal" />
      )
    )}
  </div>
);
